import '../App.css';

function AboutTwo() {
    return (
<div className="hero justify-start bg-zinc-800 font-general italic about-bg">
        <div className="flex flex-row items-center border">
        <div className="flex flex-col gap-10 ml-10 p-20 font-bold w-full">
          <p className="text-xl text-white text-center">
          As a fully licensed and insured company, we guarantee that your vehicle will receive the utmost care. Our insurance provides full coverage for any potential damage while your vehicle is in our hands. At Rescue Tyres LTD, you can trust that we have your back, ensuring you're back on the road quickly and safely.
          </p>
          </div>
        {/* <div className="hidden md:flex md:flex-col md:p-20 md:justify-center items-center md:font-bold md:w-1/4">
            <img
            src={tyreStack}
            width={200}
            className="max-w-sm pr-10" 
            alt="tyre stack"
            />
          </div>   */}
        </div>
      </div>
  );
}

export default AboutTwo;
